// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
export enum UserContext {
  Individual = 'individual',
  Company = 'company',
  Admin = 'admin',
  Staff = 'staff',
}
